import React from 'react';

import PropTypes from 'prop-types';

import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { PoweredBy, PortalWelcomeText, PortalFormWrapper } from 'components/elements';
import { SessionAccessForm } from 'components/modules';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function SessionAccessCode({ generateDirectVideoSessionTokens, appointmentId }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  return (
    <>
      <PortalFormWrapper>
        <>
          <PortalWelcomeText isForm>
            <Typography className={classes.accessCodeHint} variant="body2" component="p">
              {t('please_enter_your_appointment_access_code')}
            </Typography>
          </PortalWelcomeText>
          <SessionAccessForm appointmentId={appointmentId} onSubmit={generateDirectVideoSessionTokens} />
        </>
      </PortalFormWrapper>
      <PoweredBy />
    </>
  );
}

SessionAccessCode.propTypes = {
  generateDirectVideoSessionTokens: PropTypes.func.isRequired,
  appointmentId: PropTypes.string.isRequired,
};

export default SessionAccessCode;
